// TAX-EMAIL-CONFIRM-001 — read-only, zero-write, jurisdiction-scoped preflight for the Tax Collector Email action.
const API = process.env.REACT_APP_BACKEND_URL;

export const jurisdictionMatches = (row, sel) => {
  if (!row || !sel) return false;
  const sid = String(sel.jurisdiction_id || '').trim();
  if (sid && (sid === String(row.jurisdiction_id || '') || sid === String(row.id || ''))) return true;
  const name = String(sel.jurisdiction_name || '').trim().toUpperCase();
  return !!name && name === String(row.jurisdiction_name || '').trim().toUpperCase()
    && String(sel.jurisdiction_type || '').trim().toLowerCase() === String(row.jurisdiction_type || '').trim().toLowerCase();
};

/** Parcels (live certificate data) that carry the selected jurisdiction. */
export const parcelsForJurisdiction = (parcels, sel) =>
  (Array.isArray(parcels) ? parcels : []).filter(p => p && p.is_active !== false
    && (p.jurisdictions || []).some(j => jurisdictionMatches(j, sel)));

export const fetchTaxEmailPreflight = async (orderId, sel) => {
  const qs = new URLSearchParams();
  ['jurisdiction_id', 'jurisdiction_name', 'jurisdiction_type'].forEach(k => { if (sel?.[k]) qs.set(k, sel[k]); });
  const r = await fetch(`${API}/api/orders/${orderId}/tax-email/preflight?${qs}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) {
    const d = data?.detail;
    throw new Error(typeof d === 'string' ? d : d?.message || 'Unable to verify the Tax Collector email configuration.');
  }
  return data;
};

/** TAX-EMAIL-RECEIVED-001 / MULTIUPLOAD-001 — mark ONE jurisdiction's request received with its response document(s).
 *  `files` = File | File[]; one multipart request (all-or-nothing server side); `onProgress(0..100)` from XHR upload events. */
export const markTaxEmailReceived = (orderId, requestId, files, onProgress) => new Promise((resolve, reject) => {
  const list = Array.isArray(files) ? files : [files];
  const fd = new FormData();
  list.forEach((f) => fd.append('files', f));
  fd.append('request_id', requestId);
  const xhr = new XMLHttpRequest();
  xhr.open('POST', `${API}/api/orders/${orderId}/tax-email/received`);
  xhr.setRequestHeader('Authorization', `Bearer ${localStorage.getItem('token')}`);
  xhr.upload.onprogress = (e) => { if (onProgress && e.lengthComputable) onProgress(Math.round((e.loaded / e.total) * 100)); };
  xhr.onerror = () => reject(new Error('Network error — no documents were saved and the request was not marked received'));
  xhr.onload = () => {
    let data = {};
    try { data = JSON.parse(xhr.responseText || '{}'); } catch { /* non-JSON body */ }
    if (xhr.status >= 200 && xhr.status < 300) return resolve(data);
    const d = data?.detail;
    const err = new Error(typeof d === 'string' ? d : d?.message || 'Upload failed');
    err.failedFile = typeof d === 'object' ? d?.failed_file : undefined;
    reject(err);
  };
  xhr.send(fd);
});

export const openOrderFile = async (orderId, fileId) => {
  const r = await fetch(`${API}/api/orders/${orderId}/files/${fileId}/download`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });
  if (!r.ok) throw new Error('Failed to load document');
  window.open(URL.createObjectURL(await r.blob()), '_blank');
};
